import { render, staticRenderFns } from "./AdminUploadedTables.vue?vue&type=template&id=e2989c24&scoped=true&"
import script from "./AdminUploadedTables.vue?vue&type=script&lang=js&"
export * from "./AdminUploadedTables.vue?vue&type=script&lang=js&"
import style0 from "./AdminUploadedTables.vue?vue&type=style&index=0&id=e2989c24&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2989c24",
  null
  
)

export default component.exports